import * as THREE from "three";

/**
 * By default, we render all objects with these attributes. Because the stencil buffer is similarly
 * filled with 0 (by default), all objects will be rendered. If we wish to render a masked region,
 * we can clear the stencil buffer with a different value and then render the mask objects with the
 * stencilRef below.
 */
export const defaultStencilProperties = {
  stencilWrite: true,
  stencilRef: 0,
  stencilFunc: THREE.EqualStencilFunc,
} as const;
